import Heading from "../common/heading"
import LinkWithCount from "../common/link-with-count"
import styles from "./useful-links.module.scss"

const UsefulLinks = ({ headingClassName = "", ...props }) => {
  return (
    <div className={styles.usefulLink}>
      {props.mainHeading ? (
        <Heading className={`${headingClassName} u-mb24`} variant="h4">
          {props.mainHeading}
        </Heading>
      ) : null}
      {props.linkData.map((data, i) => {
        return (
          <>
            {data.heading ? (
              <Heading key={data.heading} className="u-mb16" variant="h5">
                {data.heading}
              </Heading>
            ) : null}
            {data.links.map((linkData, i) => {
              return (
                <LinkWithCount key={i} url={linkData.link} count={linkData.count} title={linkData.title}>
                  {linkData.title}
                </LinkWithCount>
              )
            })}
          </>
        )
      })}
    </div>
  )
}

export default UsefulLinks
